import { TABLE_COLUMNS } from "./constants";

export function buildGetOrdersVariables({ sort, cursor }) {
  const variables = {
    createdAt: {},
    vendor: "Stripe",
    ...buildQuerySortDirection({ sort, cursor })
  };

  return {
    variables: {
      origin: window.location.href,
      ...variables,
      ...(cursor && { cursor: cursor.id })
    }
  };
}

export function buildQuerySortDirection({ sort, cursor }) {
  const currentSortIsDesc = sort.direction === "desc";
  const fieldIsCreatedAt = sort.field === "createdAt";
  const useDescending = fieldIsCreatedAt
    ? !currentSortIsDesc
    : currentSortIsDesc;

  return {
    [sort.field]: {
      orderBy: useDescending ? "Descending" : "Ascending",
      ...(cursor && {
        cursor:
          sort.field === "createdAt"
            ? new Date(cursor[sort.field]).toUTCString()
            : cursor[sort.field]
      })
    }
  };
}

export function getColumnWidth({ columnWidths, index, width }) {
  const statusButtonWidth = 95;
  const isStatusButtonColumn = index === 0;

  if (isStatusButtonColumn) {
    return statusButtonWidth;
  }

  const adjustedWidth = width - statusButtonWidth;

  return columnWidths[index] || adjustedWidth / 5;
}

export const onColumnResizeHof = ({ columnWidths, setColumnWidths }) => ({
  column,
  width
}) => {
  if (!columnWidths.length) {
    setColumnWidths(new Array(6).fill(null));
  }

  const index = TABLE_COLUMNS.findIndex((c) => c.key === column.key);
  const newWidths = columnWidths;
  newWidths[index] = width;

  setColumnWidths(newWidths);
};
